import { installWeChatFontFix } from '@/composables/wechat/fontFix'

export default defineNuxtPlugin(() => {
  installWeChatFontFix()
})
